export const locale = {
  lang: "it",
  data: {
    MENU: {
      CHAT: "Chat",
    },
    CHAT: "Chat",
    SEARCH_CHAT: "Cerca conversazioni",
    WRITE_A_MESSAGE: "Scrivi un messaggio",
    NO_FOUND_CHAT: "Non ci sono conversazioni",
    START_CONVERSATION: "Inizia una conversazione",
    DO_NOT_DISTURB: "Non disturbare",
    ACTIVE: "Attivo",
    AWAY: "Non al computer",
    OFFLINE: "Offline",
    ABOUT: "Info",
    PERSONAL_INFORMATION: "Informazioni personali",
  },
};
